"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MARKETPLACE_CONTEXT_MAP = exports.GERMANY_CONTEXT_MAP = exports.ENTEL_CONTEXT_MAP = exports.DEFAULT_CONTEXT_MAP = exports.CUSTOM_CONTEXT_MAP = void 0;
var _react = _interopRequireDefault(require("react"));
var _ComparisonBody = _interopRequireDefault(require("../components/Comparison/ComparisonBody"));
var _ComparisonHeader = _interopRequireDefault(require("../components/Comparison/ComparisonHeader"));
var _DynamicPageBodyFactory = _interopRequireDefault(require("../components/DynamicPage/DynamicPageBodyFactory"));
var _DynamicPageHeaderFactory = _interopRequireDefault(require("../components/DynamicPage/DynamicPageHeaderFactory"));
var _ErrorBody = _interopRequireDefault(require("../components/Error/ErrorBody"));
var _ErrorHeader = _interopRequireDefault(require("../components/Error/ErrorHeader"));
var _QuestionFooter = require("../components/Questionnaire/QuestionFooter");
var _QuestionHeader = require("../components/Questionnaire/QuestionHeader");
var _QuestionnaireBody = _interopRequireDefault(require("../components/Questionnaire/QuestionnaireBody"));
var _RecommendationBodyWrapper = _interopRequireDefault(require("../components/Recommendation/RecommendationBodyWrapper"));
var _RecommendationHeaderTop = _interopRequireDefault(require("../components/Recommendation/RecommendationHeaderTop"));
var _RecommendationErrorPageBodyFactory = _interopRequireDefault(require("../components/RecommendationError/RecommendationErrorPageBodyFactory"));
var _RecommendationErrorPageHeaderFactory = _interopRequireDefault(require("../components/RecommendationError/RecommendationErrorPageHeaderFactory"));
var _HeaderTop = _interopRequireDefault(require("../components/shared/HeaderTop"));
var _SummaryBody = _interopRequireDefault(require("../components/Summary/SummaryBody"));
var _EntelErrorBody = _interopRequireDefault(require("../components/Error/entel/EntelErrorBody"));
var _TopFeatures = _interopRequireDefault(require("../components/Recommendation/ProductCard/TopFeatures"));
var _EntelTopFeatures = _interopRequireDefault(require("../components/Recommendation/ProductCard/EntelTopFeatures/EntelTopFeatures"));
var _r10SourceLibrary = require("r10-source-library");
var _EntelLoader = _interopRequireDefault(require("../components/CutomLoader/EntelLoader"));
var _EntelStepper = _interopRequireDefault(require("../components/EntelStepper"));
var _Stepper = _interopRequireDefault(require("../components/Stepper"));
var _RecommendationAirtimePlans = _interopRequireDefault(require("../components/Recommendation/RecommendationAirtimePlans/RecommendationAirtimePlans"));
var _EntelPlans = _interopRequireDefault(require("../components/Recommendation/RecommendationAirtimePlans/Entel/EntelPlans"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ComparisonFooter = _interopRequireDefault(require("../components/Comparison/ComparisonFooter"));
var _RecommendationFooter = _interopRequireDefault(require("../components/Recommendation/RecommendationFooter"));
var _MaacBusinessSolutions = _interopRequireDefault(require("../components/Recommendation/RecommendationBusinessSolution/Maac_ie/MaacBusinessSolutions"));
var _RecommendationBusinessSolution = _interopRequireDefault(require("../components/Recommendation/RecommendationBusinessSolution/Entel/RecommendationBusinessSolution"));
var _AlternativePlanRecommendation = _interopRequireDefault(require("../components/Recommendation/RecommendationAirtimePlans/Entel/AlternativePlanRecommendation"));
var _QuestionTitle = _interopRequireDefault(require("../components/Questionnaire/QuestionTitle"));
var _RecommendationBroadbandContainer = _interopRequireDefault(require("../components/Recommendation/RecommendationBroadband/RecommendationBroadbandContainer"));
var _RecommendationBroadbandTabs = _interopRequireDefault(require("../components/Recommendation/RecommendationBroadband/RecommendationBroadbandTabs"));
var _BroadbandSummary = _interopRequireDefault(require("../components/Summary/BroadbandSummary"));
var _Header = _interopRequireDefault(require("../components/Recommendation/Header"));
var _GermanyErrorBody = _interopRequireDefault(require("../components/Error/GermanyErrorBody"));
var _StarsRatingFeedback = _interopRequireDefault(require("../components/StarsRatingFeedback/StarsRatingFeedback"));
var _RecommendationSummary = _interopRequireDefault(require("../components/Recommendation/RecommendationSummary"));
var _EntelSummarySection = _interopRequireDefault(require("../components/Recommendation/RecommendationAirtimePlans/Entel/EntelSummarySection"));
var _EntelIntroScreen = _interopRequireDefault(require("../components/EntelIntroScreen"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Wrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const QuestionnaireBodyWrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const HeaderWrapper = _styledComponents.default.div`
  padding: 12px 10px 0;
`;
const DEFAULT_CONTEXT_MAP = {
  QUESTIONNAIRE: {
    header: /*#__PURE__*/_react.default.createElement(_QuestionHeader.QuestionHeader, null),
    body: /*#__PURE__*/_react.default.createElement(_QuestionnaireBody.default, null),
    footer: /*#__PURE__*/_react.default.createElement(_QuestionFooter.QuestionFooter, null),
    loader: _r10SourceLibrary.Loader,
    stepper: _Stepper.default
  },
  SUMMARY: {
    header: /*#__PURE__*/_react.default.createElement(_HeaderTop.default, null),
    body: /*#__PURE__*/_react.default.createElement(_SummaryBody.default, null),
    loader: _r10SourceLibrary.Loader,
    stepper: _Stepper.default
  },
  RECOMMENDATION: {
    header: /*#__PURE__*/_react.default.createElement(_RecommendationHeaderTop.default, null),
    body: /*#__PURE__*/_react.default.createElement(_RecommendationBodyWrapper.default, null),
    topFeatures: _TopFeatures.default,
    stepper: _Stepper.default,
    plans: _RecommendationAirtimePlans.default,
    broadband: _RecommendationBroadbandTabs.default,
    businessSolutions: _RecommendationBusinessSolution.default,
    starRatingInput: _StarsRatingFeedback.default,
    recommendationSummary: _RecommendationSummary.default
  },
  ERROR: {
    header: /*#__PURE__*/_react.default.createElement(_ErrorHeader.default, null),
    body: /*#__PURE__*/_react.default.createElement(_ErrorBody.default, null),
    stepper: _Stepper.default
  },
  COMPARISON: {
    header: /*#__PURE__*/_react.default.createElement(_ComparisonHeader.default, null),
    body: /*#__PURE__*/_react.default.createElement(_ComparisonBody.default, null),
    stepper: _Stepper.default
  },
  DYNAMIC: {
    header: /*#__PURE__*/_react.default.createElement(_DynamicPageHeaderFactory.default, null),
    body: /*#__PURE__*/_react.default.createElement(_DynamicPageBodyFactory.default, null),
    stepper: _Stepper.default
  },
  RECOMMENDATION_ERROR: {
    header: /*#__PURE__*/_react.default.createElement(_RecommendationErrorPageHeaderFactory.default, null),
    body: /*#__PURE__*/_react.default.createElement(_RecommendationErrorPageBodyFactory.default, null),
    stepper: _Stepper.default
  }
};
exports.DEFAULT_CONTEXT_MAP = DEFAULT_CONTEXT_MAP;
const ENTEL_CONTEXT_MAP = {
  QUESTIONNAIRE: {
    header: /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_QuestionHeader.QuestionHeader, null)),
    body: /*#__PURE__*/_react.default.createElement(QuestionnaireBodyWrapper, null, /*#__PURE__*/_react.default.createElement(_QuestionnaireBody.default, null)),
    footer: /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_QuestionFooter.QuestionFooter, null)),
    loader: _EntelLoader.default,
    stepper: _EntelStepper.default,
    introScreen: _EntelIntroScreen.default
  },
  SUMMARY: {
    header: /*#__PURE__*/_react.default.createElement(_HeaderTop.default, {
      isCloseButtonHidden: true
    }),
    body: /*#__PURE__*/_react.default.createElement(_SummaryBody.default, null),
    loader: _EntelLoader.default
  },
  RECOMMENDATION: {
    header: /*#__PURE__*/_react.default.createElement(_RecommendationHeaderTop.default, null),
    body: /*#__PURE__*/_react.default.createElement(_RecommendationBodyWrapper.default, null),
    footer: /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_RecommendationFooter.default, null)),
    topFeatures: _EntelTopFeatures.default,
    plans: _EntelPlans.default,
    alternativePlans: _AlternativePlanRecommendation.default,
    starRatingInput: _StarsRatingFeedback.default,
    recommendationSummary: _EntelSummarySection.default
  },
  ERROR: {
    header: /*#__PURE__*/_react.default.createElement(_HeaderTop.default, null),
    body: /*#__PURE__*/_react.default.createElement(_EntelErrorBody.default, null)
  },
  COMPARISON: {
    header: /*#__PURE__*/_react.default.createElement(_ComparisonHeader.default, {
      showHeaderTitle: false,
      showBackArrow: false
    }),
    body: /*#__PURE__*/_react.default.createElement(_ComparisonBody.default, null),
    footer: /*#__PURE__*/_react.default.createElement(_ComparisonFooter.default, {
      showBackButton: true
    })
  },
  DYNAMIC: {
    header: /*#__PURE__*/_react.default.createElement(_DynamicPageHeaderFactory.default, null),
    body: /*#__PURE__*/_react.default.createElement(_DynamicPageBodyFactory.default, null)
  },
  RECOMMENDATION_ERROR: {
    header: /*#__PURE__*/_react.default.createElement(_RecommendationErrorPageHeaderFactory.default, null),
    body: /*#__PURE__*/_react.default.createElement(_RecommendationErrorPageBodyFactory.default, null)
  }
};
exports.ENTEL_CONTEXT_MAP = ENTEL_CONTEXT_MAP;
const MARKETPLACE_CONTEXT_MAP = {
  QUESTIONNAIRE: {
    header: /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_QuestionHeader.QuestionHeader, null)),
    body: /*#__PURE__*/_react.default.createElement(QuestionnaireBodyWrapper, null, /*#__PURE__*/_react.default.createElement(_QuestionnaireBody.default, null)),
    footer: /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_QuestionFooter.QuestionFooter, null)),
    loader: _r10SourceLibrary.Loader,
    stepper: _EntelStepper.default
  },
  SUMMARY: {
    header: /*#__PURE__*/_react.default.createElement(_HeaderTop.default, {
      isCloseButtonHidden: true
    }),
    body: /*#__PURE__*/_react.default.createElement(_SummaryBody.default, null),
    loader: _r10SourceLibrary.Loader
  },
  RECOMMENDATION: {
    header: /*#__PURE__*/_react.default.createElement(_RecommendationHeaderTop.default, null),
    body: /*#__PURE__*/_react.default.createElement(_RecommendationBodyWrapper.default, null),
    footer: /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_RecommendationFooter.default, null)),
    topFeatures: _EntelTopFeatures.default,
    plans: _EntelPlans.default,
    businessSolutions: _MaacBusinessSolutions.default,
    starRatingInput: _StarsRatingFeedback.default,
    recommendationSummary: _RecommendationSummary.default
  },
  ERROR: {
    header: /*#__PURE__*/_react.default.createElement(_ErrorHeader.default, null),
    body: /*#__PURE__*/_react.default.createElement(_ErrorBody.default, null)
  },
  COMPARISON: {
    header: /*#__PURE__*/_react.default.createElement(_ComparisonHeader.default, {
      showHeaderTitle: false,
      showBackArrow: false
    }),
    body: /*#__PURE__*/_react.default.createElement(_ComparisonBody.default, null),
    footer: /*#__PURE__*/_react.default.createElement(_ComparisonFooter.default, {
      showBackButton: true
    })
  },
  DYNAMIC: {
    header: /*#__PURE__*/_react.default.createElement(_DynamicPageHeaderFactory.default, null),
    body: /*#__PURE__*/_react.default.createElement(_DynamicPageBodyFactory.default, null)
  },
  RECOMMENDATION_ERROR: {
    header: /*#__PURE__*/_react.default.createElement(_RecommendationErrorPageHeaderFactory.default, null),
    body: /*#__PURE__*/_react.default.createElement(_RecommendationErrorPageBodyFactory.default, null)
  }
};
exports.MARKETPLACE_CONTEXT_MAP = MARKETPLACE_CONTEXT_MAP;
const GERMANY_CONTEXT_MAP = {
  QUESTIONNAIRE: {
    header: /*#__PURE__*/_react.default.createElement(HeaderWrapper, null, /*#__PURE__*/_react.default.createElement(_QuestionHeader.QuestionHeader, null)),
    body: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_QuestionTitle.default, null), " ", /*#__PURE__*/_react.default.createElement(_QuestionnaireBody.default, null), " ", /*#__PURE__*/_react.default.createElement(_QuestionFooter.QuestionFooter, null)),
    loader: _r10SourceLibrary.Loader,
    stepper: _Stepper.default
  },
  SUMMARY: {
    header: /*#__PURE__*/_react.default.createElement(HeaderWrapper, null, /*#__PURE__*/_react.default.createElement(_Header.default, null)),
    body: /*#__PURE__*/_react.default.createElement(_SummaryBody.default, null),
    loader: _BroadbandSummary.default,
    stepper: _Stepper.default
  },
  RECOMMENDATION: {
    header: /*#__PURE__*/_react.default.createElement(HeaderWrapper, null, /*#__PURE__*/_react.default.createElement(_Header.default, null)),
    body: /*#__PURE__*/_react.default.createElement(_RecommendationBodyWrapper.default, null),
    broadband: _RecommendationBroadbandContainer.default,
    stepper: _Stepper.default,
    topFeatures: _TopFeatures.default,
    businessSolutions: _RecommendationBusinessSolution.default,
    recommendationSummary: _RecommendationSummary.default
  },
  ERROR: {
    header: /*#__PURE__*/_react.default.createElement(_ErrorHeader.default, null),
    body: /*#__PURE__*/_react.default.createElement(_GermanyErrorBody.default, null)
  },
  COMPARISON: {
    header: /*#__PURE__*/_react.default.createElement(_ComparisonHeader.default, {
      showHeaderTitle: false,
      showBackArrow: false
    }),
    body: /*#__PURE__*/_react.default.createElement(_ComparisonBody.default, null),
    footer: /*#__PURE__*/_react.default.createElement(_ComparisonFooter.default, {
      showBackButton: true
    })
  },
  DYNAMIC: {
    header: /*#__PURE__*/_react.default.createElement(_DynamicPageHeaderFactory.default, null),
    body: /*#__PURE__*/_react.default.createElement(_DynamicPageBodyFactory.default, null)
  },
  RECOMMENDATION_ERROR: {
    header: /*#__PURE__*/_react.default.createElement(_RecommendationErrorPageHeaderFactory.default, null),
    body: /*#__PURE__*/_react.default.createElement(_RecommendationErrorPageBodyFactory.default, null)
  }
};

// to be updated with atlas ui
exports.GERMANY_CONTEXT_MAP = GERMANY_CONTEXT_MAP;
const CUSTOM_CONTEXT_MAP = {
  QUESTIONNAIRE: {
    body: /*#__PURE__*/_react.default.createElement("div", null, "Questions")
  }
};
exports.CUSTOM_CONTEXT_MAP = CUSTOM_CONTEXT_MAP;